import React from "react";

const ContactModalButton = ({
    children,
    className = "edu-btn btn-secondary",
    type = "button",
    onClick,
}) => {
    const handleClick = (e) => {
        e.preventDefault();

        if (typeof onClick === "function") {
            onClick(e);
        }

        if (window.openContactModal) {
            window.openContactModal();
        }
    };

    return (
        <button type={type} className={className} onClick={handleClick}>
            {children}
        </button>
    );
};

export default ContactModalButton;